import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

import ItemService from "../../../../services/commonService";
import { AlertModal } from "../../../common/AlertModal";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import { InputField } from "../../../../common/formElements/InputField";

//Redux
import { useSelector } from "react-redux";

const ConsumptionQuantityModal = (props) => {
  const { t } = useTranslation();

  let userData = useSelector((state) => state?.user?.data); // User Details from Store
  const [consumptionReasonsList, setConsumptionReasonsList] = useState([]);
  const [formData, setFormData] = useState({});
  const [pendingEntries, setPendingEntries] = useState([]);
  const [isAlert, setIsAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [jobcardDetails, setJobcardDetails] = useState(props.jobcardDetails);

  const { show, onHide, title } = props;

  useEffect(() => {
    if (show) {
      setPendingEntries(props.pendingConsumptionData || []);
      setFormData({});
      setJobcardDetails(props.jobcardDetails);

      if (props.consumptionReasonsList?.length > 0) {
        setConsumptionReasonsList(props.consumptionReasonsList);
        const initialData = {};
        props.consumptionReasonsList.forEach((row, index) => {
          initialData[index] = {
            consumptionType: row.consumptionType || "",
            consumableSize: null,
            consumptionCode: "",
            quantity: "",
          };
        });
        setFormData(initialData);
      } else {
        loadAllReasons();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, props.consumptionReasonsList, props.pendingConsumptionData]);

  const loadAllReasons = async () => {
    try {
      setLoading(true);
      const param = {
        deptCode: jobcardDetails.toDeptCode,
        sizeCode: jobcardDetails.sizeCode,
      };

      const item = await ItemService.getConsumptionReasons(param);

      if (item?.status === 200) {
        const list = item?.data || [];

        setConsumptionReasonsList(list);

        const initialData = {};

        list.forEach((row, index) => {
          initialData[index] = {
            consumptionType: row.consumptionType || "",
            consumableSize: null,
            consumptionCode: "",
            quantity: "",
          };
        });

        setFormData(initialData);
      } else {
        toast.error(item?.message || "Please try again", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      toast.error("Something went wrong while loading consumption reasons", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDropdownChange = (index, value) => {
    setFormData((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        consumableSize: value,
        consumptionCode: value?.consumptionCode || "",
      },
    }));
  };

  const handleQuantityChange = (index, value) => {
    setFormData((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        quantity: value,
      },
    }));
  };

  const handleAddToPendingList = (index) => {
    const currentItem = formData[index] || {};
    const selectedSize = currentItem.consumableSize?.consumableSize || "";
    const quantity = Number(currentItem.quantity || 0);

    if (!selectedSize || !quantity || quantity <= 0) {
      setIsAlert(true);
      return;
    }

    const nextEntry = {
      consumptionType: currentItem.consumptionType || "",
      consumptionCode: currentItem.consumptionCode || "",
      consumableSize: selectedSize,
      quantity,
      createdUserId: userData.userId|| "",
      createdUserName: userData.firstName|| "",
      createdDate: new Date().toISOString(),
    };

    setPendingEntries((prev) => {
      const filtered = prev.filter(
        (entry) => entry.consumptionType !== nextEntry.consumptionType,
      );
      return [...filtered, nextEntry];
    });

    setFormData((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        consumableSize: null,
        consumptionCode: "",
        quantity: "",
      },
    }));
  };

  const handleDeletePendingEntry = (consumptionType) => {
    setPendingEntries((prev) =>
      prev.filter((entry) => entry.consumptionType !== consumptionType),
    );
  };

  const handleCancel = () => {
    setFormData({});
    setPendingEntries([]);
    onHide();
  };

  const resetAlert = () => {
    setIsAlert(false);
  };

  const handleOk = () => {
    if(pendingEntries.length === 0){
      handleSaveConsumption([]);
      return;
    }

    const selectedData = pendingEntries.map((item) => ({
      consumptionType: item.consumptionType,
      consumptionCode: item.consumptionCode,
      consumableSize: item.consumableSize || "",
      quantity: Number(item.quantity || 0),
    }));

    const hasInvalid = selectedData.some(
      (item) =>
        !item.consumableSize ||
        item.quantity === "" ||
        item.quantity === null ||
        item.quantity === undefined ||
        isNaN(item.quantity) ||
        Number(item.quantity) < 0,
    );

    if (selectedData.length === 0 || hasInvalid) {
      setIsAlert(true);
      return;
    }
    handleSaveConsumption(selectedData);
  };

  const handleSaveConsumption = async (selectedData) => {
    const params = selectedData.map((item) => ({
      deptCode: jobcardDetails.toDeptCode,
      deptName: jobcardDetails.toDeptName,
      machineCode: jobcardDetails.toMachineCode,
      machineName: jobcardDetails.toMachineName,
      sizeCode: jobcardDetails.sizeCode,
      sizeName: jobcardDetails.sizeName,
      jobcard: jobcardDetails.jobcard,
      ...item,
      createdUserId: userData.userId|| "",
      createdUserName: userData.firstName|| "",
      createdDate: new Date().toISOString(),
    }));

    props.onSaveSuccess(params);

    // await ItemService.saveConsumptionQty(params).then((item) => {
    //   // console.log(">> Update Details res!", item);
    //   if (item?.status === 200) {
    //     props.onSaveSuccess(params[0]);
    //     toastFunc(Constants.MASTER.TOAST.success, item.message, 2000);
    //   } else {
    //     toastFunc(Constants.MASTER.TOAST.error, "Invalid Input", 4000);
    //   }
    // });

    onHide();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        dialogClassName="modal-70w"
        aria-labelledby="example-custom-modal-styling-title"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            {title}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" />
              <div className="mt-3 text-muted">
                {t("msg_master_list.msg_consumable.consumable_loading")}
              </div>
            </div>
          ) : consumptionReasonsList.length === 0 ? (
            <Card className="border-0">
              <Card.Body className="text-center text-muted py-5">
                {t("msg_master_list.msg_consumable.no_consumable_data")}
              </Card.Body>
            </Card>
          ) : (
            consumptionReasonsList.map((item, index) => (
              <div key={index} className="mb-3">
                <Row className="align-items-end">
                  <Col lg={3} md={3} sm={12} className="mb-2">
                    <small className="block font-medium text-gray-900">
                      {t("msg_master_list.msg_consumable.ConsumptionType")}
                    </small>
                    <div
                      className="bg-table-status bg-table-new-status"
                      style={{
                        width: "180px",
                      }}
                    >
                      {item.consumptionType}
                    </div>
                  </Col>

                  <Col lg={4} md={4} sm={12} className="commLeftRightPadding">
                    <DropdownListField
                      id={`consumableSize_${index}`}
                      name="consumableSize"
                      className="dropdownHive w-100 rounded mb-1"
                      label={t(
                        "msg_master_list.msg_consumable.select_consumable_size",
                      )}
                      data={item.data || []}
                      textField="consumableSize"
                      dataItemKey="consumptionCode"
                      value={formData[index]?.consumableSize || null}
                      onChange={(value) => handleDropdownChange(index, value)}
                      placeholder={t(
                        "msg_master_list.msg_consumable.select_consumable_size",
                      )}
                      autoFocus={index === 0}
                    />
                  </Col>

                  <Col lg={4} md={4} sm={12} className="commLeftRightPadding">
                    <InputField
                      label={t("msg_master_list.msg_consumable.enter_qty")}
                      name={`quantity`}
                      id={`quantity_${index}`}
                      placeholder={t(
                        "msg_master_list.msg_consumable.enter_qty",
                      )}
                      type="number"
                      min="0"
                      value={formData[index]?.quantity || ""}
                      className="commLeftRightPadding"
                      onChange={(e) =>
                        handleQuantityChange(index, e.target.value)
                      }
                    />
                  </Col>

                  <Col lg={1} md={1} sm={12} className="commLeftRightPadding">
                    <Button
                      type="button"
                      variant="primary"
                      onClick={() => handleAddToPendingList(index)}
                      disabled={loading}
                    >
                      Add
                    </Button>
                  </Col>
                </Row>
              </div>
            ))
          )}

          {pendingEntries.length > 0 && (
            <Card className="border mt-3">
              <Card.Header className="bg-light">
                <strong>Pending Consumption Entries</strong>
              </Card.Header>
              <Card.Body className="p-0">
                <div className="table-responsive">
                  <table className="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>Consumption Type</th>
                        <th>Size</th>
                        <th>Qty</th>
                        <th>User</th>
                        <th>Date/Time</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingEntries.map((entry, index) => (
                        <tr key={`${entry.consumptionType}-${index}`}>
                          <td>{entry.consumptionType}</td>
                          <td>{entry.consumableSize}</td>
                          <td>{entry.quantity}</td>
                          <td>{entry.createdUserId} - {entry.createdUserName}</td>
                          <td>{new Date(entry.createdDate).toLocaleString()}</td>
                          <td>
                            <Button
                              variant="danger"
                              size="sm"
                              onClick={() =>
                                handleDeletePendingEntry(entry.consumptionType)
                              }
                            >
                              <i className="bi bi-trash3"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Card.Body>
            </Card>
          )}

          {Array.isArray(props.savedConsumptionData) &&
            props.savedConsumptionData.length > 0 && (
              <Card className="border mt-3">
                <Card.Header className="bg-light">
                  <strong>Saved Consumption Entries</strong>
                </Card.Header>
                <Card.Body className="p-0">
                  <div className="table-responsive">
                    <table className="table table-sm mb-0">
                      <thead>
                        <tr>
                          <th>Consumption Type</th>
                          <th>Size</th>
                          <th>Qty</th>
                          <th>User</th>
                          <th>Date/Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {props.savedConsumptionData.map((entry, index) => (
                          <tr key={`${entry.consumptionType}-${index}`}>
                            <td>{entry.consumptionType}</td>
                            <td>{entry.consumableSize || "-"}</td>
                            <td>{entry.quantity || "-"}</td>
                            <td>
                              {entry.createdUserId} - {entry.createdUserName}
                            </td>
                            <td>
                              {entry.createdDate}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Card.Body>
              </Card>
            )}
        </Modal.Body>

        <Modal.Footer className="bg-white">
          <Button variant="secondary" onClick={handleCancel}>
            {t("msg_common.cancel")}
          </Button>

          <Button variant="success" onClick={handleOk} disabled={loading}>
            {t("msg_common.save")}
          </Button>
        </Modal.Footer>
      </Modal>

      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={t("msg_master_list.msg_consumable.enter_valid_qty_size")}
          onHide={resetAlert}
        />
      )}
    </>
  );
};

export default ConsumptionQuantityModal;
